import { memo } from 'react';

import ReviewIconSVG from '@/assets/review-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IReviewIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ReviewIconSVG} {...props} />;

export const ReviewIcon = memo(IReviewIcon) as typeof IReviewIcon;
